// Confirmação de DESATIVAÇÃO de uma configuração.
//
// Desativar nunca é silencioso: tira uma credencial do roteamento, e quando é
// a última ativa do par o meio de pagamento para de rotear — daí o aviso extra.
import { useTranslation } from "react-i18next"

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import type {
  ProcessorConfigItem,
  ProcessorPaymentMethod,
} from "@/types/admin-processor-config"

const panelPrefix = "pages.adminProcessorConfig"

interface DeactivateConfigDialogProps {
  /** `null` mantém o diálogo fechado. */
  pending: ProcessorConfigItem | null
  /** Última configuração ativa do par — aciona o aviso âmbar. */
  isLastActiveOfPair: boolean
  /** Método traduzido; o enum cru nunca aparece para o operador. */
  methodLabelOf: (method: ProcessorPaymentMethod) => string
  onConfirm: () => void
  onClose: () => void
}

export const DeactivateConfigDialog = ({
  pending,
  isLastActiveOfPair,
  methodLabelOf,
  onConfirm,
  onClose,
}: DeactivateConfigDialogProps) => {
  const { t } = useTranslation()

  return (
    <AlertDialog
      open={pending !== null}
      onOpenChange={(open) => {
        if (!open) onClose()
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t(`${panelPrefix}.deactivate.title`)}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t(`${panelPrefix}.deactivate.description`, {
              method: pending
                ? methodLabelOf(pending.method)
                : "",
              whiteLabel: pending?.whiteLabelName ?? "",
            })}
          </AlertDialogDescription>
          {isLastActiveOfPair && (
            <div className="rounded-md border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800">
              {t(
                `${panelPrefix}.deactivate.lastActiveWarning`
              )}
            </div>
          )}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>
            {t(`${panelPrefix}.deactivate.cancel`)}
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            {t(`${panelPrefix}.deactivate.confirm`)}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
